var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text"},[_c('input',{attrs:{"type":"text","placeholder":_vm.label},on:{"input":function($event){return _vm.$emit('inputchange', $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }